<template>
  <ADSCardSection
    :isAccordion="true"
    :isLoading="false"
    sectionId="testID"
  >
    <template #header>
      Virology OATS Preview
    </template>
    <template #body>
      <b> {{ virologyListOATS.length }} results found on {{ virologyListOATS?.[0]?.testDate ?? 'N/A' }} </b> 
     
      <div class="sections">
        <div v-if="virologyListOATS.length === 0">
          <div class="row">
            <div class="col-2">
              <ADSTextInput
                disabled
                label="Test Result"
              />
            </div>
            <div class="col-2">
              <ADSTextInput
                disabled
                label="Code"
              />
            </div>
            <div class="col-2">
              <ADSTextInput
                disabled
                label="Test Date"
              />
            </div>
          </div>
        </div>
        <div
          v-for="( item, index ) in virologyListOATS"
          :key="item"
        >
          <!-- <br> -->
          <div class="row">
            <div class="col-2">
              <ADSTextInput
                v-model="item.sampleCode"
                disabled
                label="Code"
              />
            </div>
            <div class="col-2">
              <ADSTextInput
                v-model="item.testResult"
                disabled
                :label="`Test Result ${index + 1}`"
              />
            </div>
            <div class="col-2">
              <ADSTextInput
                v-model="item.testDate"
                disabled
                label="Test Date"
              />
            </div>
          </div>
          <hr class="lineBreak">
        </div>
      </div>
    </template>
  </ADSCardSection>
</template>

<script>
import _ from 'lodash';
// eslint-disable-next-line no-unused-vars
import { ORGAN_LIST } from '../constants';
// eslint-disable-next-line no-unused-vars
import { RECIPIENT_VIROLOGY_LOIN_CODES, RECIPIENT_VIROLOGY_CODES_MAPPING, LIVING_DONOR_VIROLOGY_CODES_MAPPING } from "@/constants";

export default {
  name: "VirologySectionDetailsDonorEMROATS",
  props: {
    patient: {
      type: Object,
      default: null,
    },
    patientBundle: {
      type: Object,
      default: null,
    },
    patientType:{
      type: String,
      default: null
    },
    patientBundleOATS: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      virologyList: this.getVirologyList( this.patientBundle ),
      virologyListOATS: this.getVirologyListOATS( this.patientBundleOATS ),
    };
    },
   mounted() {
    
    },
  methods: {
    combineProps() {
      return `${this.patient}`;
    },
    getVirologyList( patientBundle ) {
      const entries = _.get( patientBundle, 'entries', [] );
      if ( !Array.isArray( entries ) || entries.length === 0 ) return [];

      const observationGroups = entries.filter(
        ( n ) =>
          _.get( n[0], 'resource.resourceType' ) === 'Observation' &&
          _.get( n[0], 'resource.category[0].coding[0].code' ) === 'smartdata'
      );

      const observations = observationGroups && observationGroups[0];
      if ( !Array.isArray( observations ) || observations.length === 0 ) return [];

      const config =
        this.patientType === 'Recipient'
          ? [
              { resultCode: 'SK#8259', dateCode: 'SK#8260', sampleCode: 'HTLV1' },
              { resultCode: 'SK#8256', dateCode: 'SK#8257', sampleCode: 'HIV_NAT' },
              { resultCode: 'UHN#3838', dateCode: 'UHN#3839', sampleCode: 'CMV_IGG_AB' },
              { resultCode: 'SK#8011', dateCode: 'SK#8012', sampleCode: 'EBV_CAPSID_AB' },
              { resultCode: 'UHN#3858', dateCode: 'UHN#3859', sampleCode: 'EBV_EARLY_AB' },
              { resultCode: 'SK#8014', dateCode: 'SK#8015', sampleCode: 'HBV_SURFACE_AG' },
              { resultCode: 'SK#8017', dateCode: 'SK#8018', sampleCode: 'HBV_CORE_AB' },
              { resultCode: 'SK#8020', dateCode: 'SK#8021', sampleCode: 'HBV_AB' },
              { resultCode: 'SK#8233', dateCode: 'SK#8234', sampleCode: 'HCV_AB' },
              { resultCode: 'SK#8236', dateCode: 'SK#8237', sampleCode: 'HBV_NAT' },
              { resultCode: 'SK#8239', dateCode: 'SK#8240', sampleCode: 'HCV_NAT' },
              { resultCode: 'SK#8253', dateCode: 'SK#8254', sampleCode: 'HIV' },
              { resultCode: 'SK#8256', dateCode: 'SK#8257', sampleCode: 'HIV_NAT' },
              { resultCode: 'SK#8259', dateCode: 'SK#8260', sampleCode: 'HTLV1' },
              { resultCode: 'SK#8262', dateCode: 'SK#8263', sampleCode: 'TOXOPLASMOSIS' },
              { resultCode: 'SK#8265', dateCode: 'SK#8266', sampleCode: 'Syphillis' },
              { resultCode: 'SK#8268', dateCode: 'SK#8269', sampleCode: 'VZV_AB' },
              { resultCode: 'SK#8271', dateCode: 'SK#8272', sampleCode: 'MEASLES_AB' },
              { resultCode: 'UHN#3900', dateCode: 'UHN#3901', sampleCode: 'MUMPS_AB' },
              { resultCode: 'SK#8277', dateCode: 'SK#8278', sampleCode: 'RUBELLA_AB' },
            ]
          : [
              { resultCode: 'UHN#3923', dateCode: 'UHN#3924', sampleCode: 'HIV_NAT' },
              { resultCode: 'UHN#3926', dateCode: 'UHN#3927', sampleCode: 'HCV_NAT' },
              { resultCode: 'UHN#3929', dateCode: 'UHN#3930', sampleCode: 'CMV_IGG_AB' },
              { resultCode: 'UHN#3932', dateCode: 'UHN#3933', sampleCode: 'HBV_CORE_AB' },
              { resultCode: 'UHN#3935', dateCode: 'UHN#3936', sampleCode: 'HBV_AB' },
              { resultCode: 'SK#8002', dateCode: 'SK#8003', sampleCode: 'HBV_SURFACE_AG' },
              { resultCode: 'UHN#3941', dateCode: 'UHN#3942', sampleCode: 'HCV_AB' },
              { resultCode: 'UHN#3944', dateCode: 'UHN#3945', sampleCode: 'HIV' },
              { resultCode: 'UHN#3947', dateCode: 'UHN#3948', sampleCode: 'HTLV1' },
              { resultCode: 'UHN#3950', dateCode: 'UHN#3951', sampleCode: 'Syphillis' },
              { resultCode: 'UHN#3953', dateCode: 'UHN#3954', sampleCode: 'EBV_CAPSID_AB' },
              { resultCode: 'UHN#3912', dateCode: 'UHN#3913', sampleCode: 'WEST_NILE_IGM' },
            ];

      const configByResultCode = new Map( config.map( ( c ) => [ c.resultCode, c ] ) );
      const dateCodesWanted = new Set( config.map( ( c ) => c.dateCode ) );

      // Index test dates once (first match wins, same as prior `filter()[0]` behavior).
      const testDateByCode = Object.create( null );
      for ( const item of observations ) {
        const code = _.get( item, 'resource.code.coding[0].code' );
        if ( dateCodesWanted.has( code ) && testDateByCode[ code ] === undefined ) {
          testDateByCode[ code ] = _.get( item, 'resource.component[0].valueDateTime' );
        }
      }

      // Preserve original output ordering by iterating observations in-place.
      const virologyList = [];
      for ( const item of observations ) {
        const code = _.get( item, 'resource.code.coding[0].code' );
        const cfg = configByResultCode.get( code );
        if ( !cfg ) continue;

        virologyList.push( {
          testResult: _.get( item, 'resource.component[0].valueString', '' ),
          testDate: testDateByCode[ cfg.dateCode ],
          sampleCode: cfg.sampleCode,
        } );
      }

      return virologyList;
    },
    getVirologyListOATS( patientBundleOATS ) { 
      const virology_labs = patientBundleOATS.virologies;
      if ( !Array.isArray( virology_labs ) || virology_labs.length === 0 ) return [];
      const results = virology_labs[ 0 ].results;
      if ( !Array.isArray( results ) || results.length === 0 ) return [];

      const virologyList = [];
      for ( const item of results ) {
        let result = item.initial_result;
        if( result === 'N' ) {
          result = 'Negative';
        } else if( result === 'U' ) {
          result = 'Untested';
        } else if( result === 'P' ) {
          result = 'Positive';
        } else if( result === 'UD' ) {
          result = 'Undetermined';
        }
        virologyList.push( {
          testResult: result,
          testDate: virology_labs[ 0 ].test_date?.substring( 0,10 ),
          sampleCode: item.code,
        } );
      }
      return virologyList;
    },
    getSampleCode( code ) {
      if( this.patientType === 'Recipient' )
      return RECIPIENT_VIROLOGY_CODES_MAPPING[ code ];
      else {
        return LIVING_DONOR_VIROLOGY_CODES_MAPPING[ code ]
      }
      
    }
  },
};
</script>

<style scoped>

.card {
  /* height: 100%; */
  /* height: 450px; */
}

.sectionHeading {
  background-color: rgb(59, 53, 53);
  color: white;
  padding-left: 5px;
}

.page-content .summary-card .card-header .summary-name {
  padding-left: 35px;
  padding-top: 4px;
  font-weight: 300;
}

.sections {
  font-size: 15px;
  height: 650px;
  width: 1400px;
  overflow: scroll;
  padding-left: 10px;
  padding-top: 5px;
}

.inputDisplay {
border-style: solid;
background-color: #F2F2F2;
}

.inputDisplayComments {
  border-style: solid;
  width: 650px;
  background-color: #F2F2F2;
}

.textArea
   {
  width: 650px;
  height: 50px;
  background-color: #F2F2F2;
}

.fieldName {
  font-weight: 700;
  font-size: 0.875rem;
  padding-top: 5.5px;
  padding-bottom: 2.5px;
}

.lineBreak {
  /* color: black;
  height: 2px; */
  background-color: rgb(59, 53, 53);
  border: 0 none;
    /* color: black; */
  height: 5px;
}

:deep(.afflo-ds-form-control) {
  width: max-content;
}

:deep(label) {
  width: max-content;
}

:deep(.comments .afflo-ds-form-control) {
  width: 500px;
}

</style>
